import React, { Fragment } from 'react';
import styles from './index.module.scss';
import HeadContainer from '../head-container';
import WarningFooter from '../warning-footer/WarningFooter';
import { getImageFromS3 } from '../../imageService';
import { Disclosure, Transition } from '@headlessui/react';

const AuthorityScreen = ({
  setScreenNumber,
  setReviewScreenNumber,
  handleBackToMenu = null,
  menuButtonText = 'Повернутися до меню',
  withoutReviewButton = false,
  partners
}) => {
  return (
    <div
      className={styles.authorityContainer}
      style={{
        backgroundImage: `url("${getImageFromS3(
          'images/lm-double-splash/violet-background.png'
        )}")`
      }}
    >
      <div className={styles.content}>
        <HeadContainer setScreenNumber={setScreenNumber} telegramOnly />
        <span className={styles.title}>
          Як відрізнити оригінальні сигарети від підробки?
        </span>
        <div className={styles.descriptionContainer}>
          <p>
            Існує низка прийомів, які допоможуть відрізнити оригінал від
            підробки.<br></br> Розглянемо детально кожен з них.
          </p>
          <div className={styles.hintContainer}>
            <p>Натискай на "+"</p>
          </div>
        </div>
        <Disclosure id="excise-stamp">
          {({ open }) => (
            <>
              <Disclosure.Button className={styles.panelButton}>
                <div>
                  <p>Акцизна марка</p>
                </div>
                {open ? (
                  <img
                    src="/images/lm-double-splash/white-minus.svg"
                    alt="open-tab-icon"
                  />
                ) : (
                  <img
                    src="/images/lm-double-splash/white-plus.svg"
                    alt="open-tab-icon"
                  />
                )}
              </Disclosure.Button>
              <Transition
                as={Fragment}
                show={open}
                enter="transition duration-100 ease-out"
                enterFrom="transform scale-95 opacity-0"
                enterTo="transform scale-100 opacity-100"
                leave="transition duration-75 ease-out"
                leaveFrom="transform scale-100 opacity-100"
                leaveTo="transform scale-95 opacity-0"
              >
                <Disclosure.Panel className={styles.panelContent}>
                  Наявність української акцизної марки під плівкою пачки.
                  Акцизна марка без голограми, надрукована на тонкому папері, а
                  фарба на ній нанесена нечітко та розмито – це очевидний
                  сигнал, що перед вами підробка. Кожна акцизна марка має
                  унікальний номер. Якщо помітите, що на кількох пачках наклеєно
                  «акцизку» з однаковим номером – це підробка.
                  <div className={styles.exciseStampImageContainer}>
                    <img
                      src={getImageFromS3('images/lm-double-splash/new_1.png')}
                      alt="pack-image"
                    />
                    <img
                      src={getImageFromS3('images/lm-double-splash/new_2.png')}
                      alt="pack-image"
                    />
                  </div>
                </Disclosure.Panel>
              </Transition>
            </>
          )}
        </Disclosure>
        <Disclosure id="pack">
          {({ open }) => (
            <>
              <Disclosure.Button className={styles.panelButton}>
                <div>
                  <p>Пачка</p>
                </div>
                {open ? (
                  <img
                    src="/images/lm-double-splash/white-minus.svg"
                    alt="open-tab-icon"
                  />
                ) : (
                  <img
                    src="/images/lm-double-splash/white-plus.svg"
                    alt="open-tab-icon"
                  />
                )}
              </Disclosure.Button>
              <Transition
                as={Fragment}
                show={open}
                enter="transition duration-100 ease-out"
                enterFrom="transform scale-95 opacity-0"
                enterTo="transform scale-100 opacity-100"
                leave="transition duration-75 ease-out"
                leaveFrom="transform scale-100 opacity-100"
                leaveTo="transform scale-95 opacity-0"
              >
                <Disclosure.Panel className={styles.panelContent}>
                  <div className={styles.packItem}>
                    <img src="/images/wrong-icon.png" alt="wrong-icon" />
                    <p>
                      Фарба на підроблених пачках найчастіше нанесена нечітко,
                      іноді може жовтити або віддавати іншими відтінками, що
                      відрізняються від кольору оригіналу.
                    </p>
                  </div>
                  <div className={styles.packItem}>
                    <img src="/images/wrong-icon.png" alt="wrong-icon" />
                    <p>Тексти на пачках можуть бути нечіткими та розмитими.</p>
                  </div>
                  <div className={styles.packItem}>
                    <img src="/images/wrong-icon.png" alt="wrong-icon" />
                    <p>У текстах можуть бути помилки та опечатки.</p>
                  </div>
                  <div className={styles.packItem}>
                    <img src="/images/wrong-icon.png" alt="wrong-icon" />
                    <p>Фарба може обсипатися через неякісний друк.</p>
                  </div>
                  <div className={styles.packItem}>
                    <img
                      src="/images/correctly-icon.png"
                      alt="correctly-icon"
                    />
                    <p>
                      Кожна оригінальна пачка має бути упакована в якісне
                      целофанове пакування, яке щільно прилягає.
                    </p>
                  </div>
                </Disclosure.Panel>
              </Transition>
            </>
          )}
        </Disclosure>
        <Disclosure id="price">
          {({ open }) => (
            <>
              <Disclosure.Button className={styles.panelButton}>
                <div>
                  <p>Ціна</p>
                </div>
                {open ? (
                  <img
                    src="/images/lm-double-splash/white-minus.svg"
                    alt="open-tab-icon"
                  />
                ) : (
                  <img
                    src="/images/lm-double-splash/white-plus.svg"
                    alt="open-tab-icon"
                  />
                )}
              </Disclosure.Button>
              <Transition
                as={Fragment}
                show={open}
                enter="transition duration-100 ease-out"
                enterFrom="transform scale-95 opacity-0"
                enterTo="transform scale-100 opacity-100"
                leave="transition duration-75 ease-out"
                leaveFrom="transform scale-100 opacity-100"
                leaveTo="transform scale-95 opacity-0"
              >
                <Disclosure.Panel className={styles.panelContent}>
                  Сигарети, які коштують підозріло дешево – це вже привід
                  насторожитися та уважніше придивитися до пачки. Відповідно до
                  вимог законодавства України, на кожній пачці сигарет має бути
                  надрукована максимальна роздрібна ціна сигарет (МРЦ), а також
                  дата виробництва кожної пачки сигарет. Цю інформацію можна
                  знайти на дні пачки, вона зазвичай надрукована на чорному тлі.
                  <div className={styles.priceImageContainer}>
                    <img
                      src="/images/authority_pack_price.png"
                      alt="authority_pack_price"
                    />
                    <p>Надрукована максимальна роздрібна ціна сигарет</p>
                    <img
                      src="/images/authority_pack_date.png"
                      alt="authority_pack_date"
                    />
                    <p>Дата виробництва кожної пачки сигарет</p>
                  </div>
                </Disclosure.Panel>
              </Transition>
            </>
          )}
        </Disclosure>
        <Disclosure id="contents">
          {({ open }) => (
            <>
              <Disclosure.Button className={styles.panelButton}>
                <div>
                  <p>Вміст пачки</p>
                </div>
                {open ? (
                  <img
                    src="/images/lm-double-splash/white-minus.svg"
                    alt="open-tab-icon"
                  />
                ) : (
                  <img
                    src="/images/lm-double-splash/white-plus.svg"
                    alt="open-tab-icon"
                  />
                )}
              </Disclosure.Button>
              <Transition
                as={Fragment}
                show={open}
                enter="transition duration-100 ease-out"
                enterFrom="transform scale-95 opacity-0"
                enterTo="transform scale-100 opacity-100"
                leave="transition duration-75 ease-out"
                leaveFrom="transform scale-100 opacity-100"
                leaveTo="transform scale-95 opacity-0"
              >
                <Disclosure.Panel className={styles.panelContent}>
                  Сигарети офіційних виробників охайно і щільно вкладені в
                  пачку, завжди фільтром догори. Фарба та надписи на фільтрі
                  повинні бути чіткими і без помилок. Усередині оригінальної
                  упаковки завжди є захисна фольга або папір, який «закриває»
                  сигарети. Тютюн в оригінальних сигаретах завжди вкладений
                  щільно.{' '}
                </Disclosure.Panel>
              </Transition>
            </>
          )}
        </Disclosure>
        <Disclosure id="medical-warning">
          {({ open }) => (
            <>
              <Disclosure.Button className={styles.panelButton}>
                <div>
                  <p>Медичне попередження</p>
                </div>
                {open ? (
                  <img
                    src="/images/lm-double-splash/white-minus.svg"
                    alt="open-tab-icon"
                  />
                ) : (
                  <img
                    src="/images/lm-double-splash/white-plus.svg"
                    alt="open-tab-icon"
                  />
                )}
              </Disclosure.Button>
              <Transition
                as={Fragment}
                show={open}
                enter="transition duration-100 ease-out"
                enterFrom="transform scale-95 opacity-0"
                enterTo="transform scale-100 opacity-100"
                leave="transition duration-75 ease-out"
                leaveFrom="transform scale-100 opacity-100"
                leaveTo="transform scale-95 opacity-0"
              >
                <Disclosure.Panel className={styles.panelContent}>
                  {"Згідно із законодавством України на всіх тютюнових виробах має бути надруковано медичне попередження щодо впливу тютюнових виробів на здоров'я споживача.\n\n" +
                    "Відповідно до статті 12 Закону України «Про заходи щодо попередження та зменшення вживання тютюнових виробів і їх шкідливого впливу на здоров'я населення», на кожній пачці сигарет зазначаються  загальне попередження та комбіноване медичне попередження, що супроводжується відповідною кольоровою ілюстрацією, а також інформаційне повідомлення.\n\n" +
                    'Тексти та ілюстрації комбінованого медичного попередження, а також технічні вимоги до його макету, дизайну та форми затверджує Міністерство охорони здоров’я України.\n\n' +
                    'Медичні попередження покривають 65% від розміру зовнішньої передньої та задньої поверхонь одиничної пачки чи зовнішнього упакування сигарет та  містять кольорову ілюстрацію з обох сторін упаковки.\n\n' +
                    'Детальніше з вимогами до медичних попереджень можна ознайомитись тут: Про заходи щодо попередження... | від 22.09.2005 № 2899-IV, Про затвердження Груп наборів ко... | від 18.04.2023 № 747.'}
                  <div className={styles.medicalWarningContainer}>
                    <img
                      src="/images/medical-warning.png"
                      alt="medical-warning"
                    />
                    <p>Основне попередження</p>
                  </div>
                </Disclosure.Panel>
              </Transition>
            </>
          )}
        </Disclosure>
        <Disclosure id="duty-free">
          {({ open }) => (
            <>
              <Disclosure.Button className={styles.panelButton}>
                <div>
                  <p>Duty Free</p>
                </div>
                {open ? (
                  <img
                    src="/images/lm-double-splash/white-minus.svg"
                    alt="open-tab-icon"
                  />
                ) : (
                  <img
                    src="/images/lm-double-splash/white-plus.svg"
                    alt="open-tab-icon"
                  />
                )}
              </Disclosure.Button>
              <Transition
                as={Fragment}
                show={open}
                enter="transition duration-100 ease-out"
                enterFrom="transform scale-95 opacity-0"
                enterTo="transform scale-100 opacity-100"
                leave="transition duration-75 ease-out"
                leaveFrom="transform scale-100 opacity-100"
                leaveTo="transform scale-95 opacity-0"
              >
                <Disclosure.Panel className={styles.panelContent}>
                  {'В Україні не існує такого поняття, як сигарети Duty Free.\n\n' +
                    'Відповідно до українського законодавства, на період воєнного стану, всі тютюнові вироби, які реалізуються на території України, підлягають обов’язковому оподаткуванню акцизним податком. Сигарети без акцизної марки не можуть перебувати у вільному обігу, зберігатися з метою продажу або продаватися споживачам на території України. Відсутність акцизної марки автоматично робить таку продукцію незаконною.'}
                  <div className={styles.dutyFreeContainer}>
                    <img src="/images/duty-free.png" alt="duty-free" />
                    <p>Показник підробки</p>
                  </div>
                  {'У контексті нелегального ринку поняття «сигарети duty free» активно використовується нелегальними виробниками та продавцями як маніпулятивний інструмент. Воно покликане створити у споживача хибне відчуття легальності походження товару та виправдати його низьку ціну.\n\n' +
                    'Нелегальні виробники часто називають свою продукцію «duty free» або маркують її написами іноземною мовою, щоб пояснити відсутність акцизної марки або офіційного маркування. У свідомості покупця це асоціюється з товарами з аеропортів чи пунктів перетину кордону, які нібито продаються «без податків». Насправді ж такі сигарети не мають жодного стосунку до офіційної системи duty free і не виготовляються для законного експорту. Таким чином, термін «сигарети duty free» часто використовується для маскування контрабандної або нелегальної тютюнової продукції.'}
                </Disclosure.Panel>
              </Transition>
            </>
          )}
        </Disclosure>
        <div className={styles.partnersContainer}>
          <p>Офіційні сигарети можна придбати онлайн у офіційних партнерів</p>
          <div className={styles.partnersButtons}>
            <button>
              <a href={partners ? partners.cig : ''}>Cig-Poshta</a>
            </button>
            <button>
              <a
                href={
                  'https://rozetka.com.ua/ua/sigareti/c4638591/filter/producer=b84d5fce,bond,chesterfield,marlboro,parliament,philip-morris/?utm_source=cdacontraband'
                }
              >
                Rozetka
              </a>
            </button>
          </div>
        </div>
        <div className={styles.buttonContainer}>
          <button
            className={styles.menuButton}
            onClick={() =>
              handleBackToMenu ? handleBackToMenu() : setScreenNumber(1)
            }
          >
            {menuButtonText}
          </button>
          {!withoutReviewButton && (
            <button
              className={styles.reviewButton}
              onClick={setReviewScreenNumber}
            >
              Далі
            </button>
          )}
        </div>
      </div>
      <div className={styles.footer}>
        Дана інформація про продукт надається <br></br>відповідно до статті 15
        Закону України<br></br> «Про захист прав споживачів»
      </div>
    </div>
  );
};

export default AuthorityScreen;
